import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CallingService {

  constructor(private restService:RestService) { }


  /**
   * post contact data of current user and current client to connect with client i.e. auto caller
   * @param data contact details data
   * @returns
   */
  postCallContacts(data: any):Observable<any> {
    return this.restService.postData('calls/callcontact', data)
  }
}
